// Necessary if using App Router to ensure this file runs on the client
"use client";

import * as Sentry from "@sentry/nextjs";
import { useSession } from "next-auth/react";
import { useEffect } from "react";

export default function SentryInit() {
  const session = useSession();

  useEffect(() => {
    Sentry.setUser({
      id: session.data?.user.id || "<unknown>",
      name: session.data?.user.name || "<unknown>",
      email: session.data?.user.email || "<unknown>",
    });
  }, [session]);

  return null;
}
